import React from 'react'
import { SocialLoginPanel } from '../GoogleSignInButton'

const LoginRequiredPanel = ({ message, showSocialLogin = true }) => (
  <div className="min-h-screen relative flex items-center justify-center p-4">
    <div className="w-full max-w-md">
      <div className="bg-white/10 backdrop-blur-xl rounded-2xl shadow-2xl border border-white/20 p-8 text-center">
        <div className="mb-6">
          <div className="text-6xl mb-4">🔒</div>
          <h2 className="text-2xl font-bold text-white mb-2">Authentication Required</h2>
          <p className="text-gray-300 mb-6">
            {message || 'You need to sign in to access this content.'}
          </p>
        </div>

        <LocalAuthButtons />

        {showSocialLogin && <SocialAuthSection />}

        <SecurityMessage />
      </div>
    </div>
  </div>
)

const LocalAuthButtons = () => (
  <div className="space-y-4 mb-6">
    <a
      href="/login"
      className="w-full block bg-gradient-to-r from-purple-600 to-pink-600 hover:from-purple-700 hover:to-pink-700 text-white font-semibold py-3 px-6 rounded-xl transition-all duration-300 hover:shadow-lg"
    >
      Sign In
    </a>
    <a
      href="/register"
      className="w-full block bg-white/10 hover:bg-white/20 text-white font-semibold py-3 px-6 rounded-xl border border-white/20 hover:border-white/40 transition-all duration-300"
    >
      Create Account
    </a>
  </div>
)

const SocialAuthSection = () => (
  <>
    <div className="my-6">
      <div className="w-full border-t border-white/20 mb-2"></div>
      <div className="flex justify-center text-sm">
        <span className="text-gray-400">or continue with</span>
      </div>
    </div>
    <div className="mb-3">
      <SocialLoginPanel />
    </div>
  </>
)

const SecurityMessage = () => (
  <div className="text-center mt-6">
    <small className="text-gray-400">
      Your data is secure and protected.
    </small>
  </div>
)

export default LoginRequiredPanel